import { computed } from "vue";
import { useEnvironmentStore } from "@store/environment-store";
import { fetchSession } from "@api/web/v1/members/sessions";

export function useCurrentMember() {
  const environmentStore = useEnvironmentStore();

  const currentMember = computed(() => environmentStore.currentMember);
  const isLoggedIn = computed(() => !!environmentStore.currentMemberId);

  async function initCurrentMember() {
    try {
      const response = await fetchSession();
      const memberId = response.data.data.id;

      environmentStore.setEnvironment({
        userType: "Member",
        memberId: Number(memberId),
      });
    } catch {
      environmentStore.setEnvironment({
        userType: "Guest",
      });
    }
  }

  return {
    currentMember,
    isLoggedIn,
    initCurrentMember,
  };
}
